
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[slug]/featured",
      function () {
        return require("private-next-pages/brands/[slug]/featured.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[slug]/featured"])
      });
    }
  